/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FilterMode = {
    Include: 'Include',
    Exclude: 'Exclude'
} as const;
export type FilterMode = typeof FilterMode[keyof typeof FilterMode];


export function instanceOfFilterMode(value: any): boolean {
    for (const key in FilterMode) {
        if (Object.prototype.hasOwnProperty.call(FilterMode, key)) {
            if (FilterMode[key as keyof typeof FilterMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FilterModeFromJSON(json: any): FilterMode {
    return FilterModeFromJSONTyped(json, false);
}

export function FilterModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterMode {
    return json as FilterMode;
}

export function FilterModeToJSON(value?: FilterMode | null): any {
    return value as any;
}

export function FilterModeToJSONTyped(value: any, ignoreDiscriminator: boolean): FilterMode {
    return value as FilterMode;
}

